import { useEffect } from 'react'

// groundops.app/signup → the web app's self-serve organisation signup
// (#830 B1). A stable public URL for the mobile app's "Create your
// organisation" button, the App Store description, and campaign links —
// the target changes in exactly one place.
//
// PRODUCTION. It pointed at staging while self-serve signup was stg-only, on
// the instruction to flip it in the PR that enabled prd. That flag went on and
// was applied — `GET api.groundops.app/api/public/org-registration` answers
// `{"enabled":true}`, verified 2026-08-21 — so the redirect was sending real
// prospects into the test environment: accounts created in staging's database,
// against staging's data, reachable by nobody.
//
// The entitlement gate that made public signup safe on prd shipped first
// (#1287): both completion paths write `enterprise` + [] explicitly, so a
// stranger who signs up gets core and none of the mounted lanes.
const APP_SIGNUP_URL = 'https://app.groundops.app/signup'

export default function SignupRedirect() {
  useEffect(() => {
    window.location.replace(APP_SIGNUP_URL)
  }, [])

  // Momentary fallback while the redirect fires (and for no-JS crawlers).
  return (
    <main style={{ padding: '4rem 1.5rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <p>
        Taking you to sign-up… if nothing happens,{' '}
        <a href={APP_SIGNUP_URL}>continue to {APP_SIGNUP_URL.replace('https://', '')}</a>.
      </p>
    </main>
  )
}
